import React from "react";
import image from "../images/about.jpg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaReact, FaNodeJs, FaMobile, FaCode } from "react-icons/fa";
import { SiMongodb, SiFirebase } from "react-icons/si";

const About = () => {
  const highlights = [
    {
      icon: <FaReact />,
      title: "Frontend Leadership",
      description:
        "Leading frontend architecture and development teams, driving technical excellence in React ecosystems",
    },
    {
      icon: <FaMobile />,
      title: "Mobile Innovation",
      description:
        "Architecting cross-platform mobile solutions with React Native for banking and fintech applications",
    },
    {
      icon: <FaNodeJs />,
      title: "Full-Stack Expertise",
      description:
        "Building scalable backend systems with Node.js, Laravel, and modern cloud infrastructure",
    },
    {
      icon: <SiMongodb />,
      title: "System Architecture",
      description:
        "Designing robust, scalable architectures with AWS, Firebase, and modern databases",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <section className="section about-modern" id="about">
        <div className="section-title">
          <h2>About Me</h2>
          <div className="underline"></div>
        </div>

        <div className="about-modern-container">
          <motion.article
            className="about-image-section"
            data-aos="fade-right"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="about-image-wrapper">
              <img
                src={image}
                alt="Junaid Ahmad"
                className="about-image-modern"
              />
              <div className="about-image-overlay"></div>
            </div>

            <div className="about-stats">
              <div className="stat-item">
                <FaCode className="stat-icon" />
                <div>
                  <h4>Tech Lead</h4>
                  <p>Frontend Leadership</p>
                </div>
              </div>
              <div className="stat-item">
                <SiFirebase className="stat-icon" />
                <div>
                  <h4>Project Delivery</h4>
                  <p>End-to-End Ownership</p>
                </div>
              </div>
            </div>

            <div className="about-actions">
              <Link to="/about">
                <motion.button
                  className="btn btn-primary-modern"
                  whileTap={{ scale: 0.98 }}
                  whileHover={{ scale: 1.02 }}
                >
                  Learn More About Me
                </motion.button>
              </Link>
              <Link to="/contact">
                <motion.button
                  className="btn btn-secondary-modern"
                  whileTap={{ scale: 0.98 }}
                  whileHover={{ scale: 1.02 }}
                >
                  Get In Touch
                </motion.button>
              </Link>
            </div>
          </motion.article>

          <motion.article
            className="about-content-section"
            data-aos="fade-left"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="about-intro">
              <h3 className="about-greeting">
                Senior Frontend Engineer | Tech Lead
              </h3>
              <p className="about-tagline">
                Leading frontend architecture for scalable digital products
                with React, React Native, and modern full-stack technologies
              </p>
            </div>

            <div className="about-description">
              <p>
                Senior Frontend Engineer and Tech Lead, building mobile and web
                experiences with a focus on product quality, security, and
                performance. I partner across product, frontend, backend, and
                infrastructure to deliver user-centric solutions.
              </p>

              <p>
                Expertise spans frontend leadership, React/React Native,
                full-stack delivery, and cloud platforms like AWS and Firebase.
                I focus on scalable architecture, clean code standards, and
                mentoring teams to ship reliable products.
              </p>
            </div>

            <div className="about-highlights">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="highlight-item"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="highlight-icon">{item.icon}</div>
                  <div className="highlight-content">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.article>
        </div>
      </section>
    </motion.div>
  );
};

export default About;
